import SimpleButton from "./SimpleButton";

export default SimpleButton;
